module.exports = __webpack_public_path__ + "static/media/5.17.51b5b420.png";